import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { UtilsService } from './utils.service';
import { environment } from '../../../src/environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  emptyGuid = "00000000-0000-0000-0000-000000000000";
  constructor(    @Inject(PLATFORM_ID) private platformId: Object,
  private http: HttpClient, private utils: UtilsService) { }

  post(url: string, payload: any, httpOptions: any): Observable<any> {
    return this.http.post(url, payload, httpOptions)
  }

  getMenuList(): Observable<any> {
    let url = this.utils.apiUrl + 'Category/GetCategoryMenu';
    return this.http.get(url, { headers: this.utils.skipInterceptorHeaders });
  }

  getSubCatDataByGuid(guid: any): Observable<any> {
    let data: any = {
      "guid": guid,
      "metaInfoType": "BrandSubCategory"
    }
    let url = this.utils.apiUrl + 'LandingPage/GetMetaInformation';
    return this.http.post(url, data).pipe(catchError(this.utils.processError.bind(this)));
  }

  getFilters(guid: any, name: string, isEshop: boolean): Observable<any> {
    let body = isEshop ? {
      'EshopGuidId': this.emptyGuid,
      'EshopName': name
    } : {
      "subCatGuidId":this.emptyGuid,
      "subCatName": name
    }
    let url = this.utils.apiUrl;
    if (isEshop) {
      url += `filters/GetFiltersByEshopCategoryGuidId`
    }
    else {
      url += `filters/GetFiltersBySubCategoryGuidId`
    }
    return this.http.post(url, body, { headers: this.utils.skipInterceptorHeaders });
  }

  getPlpData(bodyData: any, isEshop: any): Observable<any> {
    let body: any = {}
    if (this.utils.getUserGuid()) {
      body['userGuid'] = this.utils.getUserGuid();
    }
    if (bodyData && bodyData.pinCode) {
      body['pinCode'] = bodyData.pinCode;
    }
    if (bodyData && bodyData.sortBy) {
      body['sortParameter'] = bodyData.sortBy.sortBy;
      body['sortByDescending'] = bodyData.sortBy.sortByDescending
    }
    if (bodyData && bodyData.seriesGuid) {
      body['seriesGuid'] = this.emptyGuid;
      body['seriesName'] = bodyData.seriesName;
    }
    if (bodyData && bodyData.subCatGuid) {
      body['brandSubCategoryGuid'] = bodyData.subCatGuid;
      body['brandSubCategoryName'] = bodyData.brandSubCategoryName
    }
    if (bodyData && (!bodyData.subCatGuid && !bodyData.seriesGuid) && !isEshop) {

      body['brandSubCategoryName'] = bodyData.brandSubCategoryName
      body['seriesName'] = bodyData.seriesName
      body['brandCategoryName']=bodyData.brandCategoryName;
    }
    if (bodyData && isEshop && bodyData.eshopGuid) {
      body['eShopName'] = bodyData.eshopName
      body['eShopGuid'] = bodyData.eshopGuid;
    }
    if (bodyData && isEshop && !bodyData.eshopGuid) {
      body['eShopName'] = bodyData.eshopName
      body['eShopGuid'] = bodyData.eshopGuid ? bodyData.eshopGuid:this.emptyGuid;
    }
    if (bodyData && bodyData.filterData) {
      body['filters'] = bodyData.filterData;
    }
    let url = this.utils.apiUrl + 'Product/GetProductCardList';
    return this.http.post(url, body, { headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)));;
  }
  getAllPressMediaData(body: any) {
    let url = `${this.utils.apiUrl}CustomerConsultation/GetAllPressMediaList`;
    return this.http.post(url, body).pipe(catchError(this.utils.processError.bind(this)));
  }
  getoffersData(bodyData: any, isEshop: any): Observable<any> {
    let body: any = {}
    if (this.utils.getUserGuid()) {
      body['userGuid'] = this.utils.getUserGuid();
    }
    if (bodyData && bodyData.pinCode) {
      body['pinCode'] = bodyData.pinCode;
    }
    if (bodyData && bodyData.sortBy) {
      body['sortParameter'] = bodyData.sortBy.sortBy;
      body['sortByDescending'] = bodyData.sortBy.sortByDescending
    }
    if (bodyData && bodyData.seriesGuid) {
      body['seriesGuid'] = this.emptyGuid;
      body['seriesName'] = bodyData.seriesName;
    }
    if (bodyData && bodyData.subCatGuid) {
      body['brandSubCategoryGuid'] = bodyData.subCatGuid;
      body['brandSubCategoryName'] = bodyData.brandSubCategoryName
    }
    if (bodyData && (!bodyData.subCatGuid && !bodyData.seriesGuid) && !isEshop) {
      body['brandSubCategoryName'] = bodyData.brandSubCategoryName
      body['seriesName'] = bodyData.seriesName
      body['brandCategoryName']=bodyData.brandCategoryName;
    }
    if (bodyData && isEshop && bodyData.eshopGuid) {
      body['eShopName'] = bodyData.eshopName
      body['eShopGuid'] = bodyData.eshopGuid;
    }
    if (bodyData && isEshop && !bodyData.eshopGuid) {
      body['eShopName'] = bodyData.eshopName
      body['eShopGuid'] = bodyData.eshopGuid ? bodyData.eshopGuid:this.emptyGuid;
    }
    if (bodyData && bodyData.filterData) {
      body['filters'] = bodyData.filterData;
    }
    let url = this.utils.apiUrl + 'LandingPage/GetOffersInfoForCustomer';
    return this.http.get(url, body).pipe(catchError(this.utils.processError.bind(this)));
  }

  getOfferDetailsByLinkAsync(data:any): Observable<any> {
    const offerLink = data.offerLink;
    let url = this.utils.apiUrl + 'Offer/GetOfferDetailsByLinkAsync?offerLink=' + encodeURIComponent(offerLink);
    return this.http.post(url, data).pipe(catchError(this.utils.processError.bind(this)));;
  }

  globalSearch(args: any): Observable<any> {
    let payload;
    if (args.length > 0) {
      payload = {
        "searchArgs": args
      }
    }
    let url = this.utils.apiUrl + 'CustomerGenericSearch/GetCustomerAllSearchListResponse';
    if (this.utils.getToken())
      return this.http.post(url, payload).pipe(catchError(this.utils.processError.bind(this)))
    else
      return this.http.post(url, payload, { headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)))
  }

  getRecentSearchedItems() {
    let url = this.utils.apiUrl + 'RecentlySearchedText/GetRecentlySearchedText';
    return this.http.get(url).pipe(catchError(this.utils.processError.bind(this)))
  }

  sendEncReq(args: any,paymentType:any): Observable<any> {
    let payload;
    payload = {
      "encryptedResponse": args,
      "userGuid": this.utils.getUserGuid()
    }
    let url = this.utils.apiUrl + `Order/SavePaymentDetailForOrder?PGName=${paymentType}`;
    if (this.utils.getToken()) {
      return this.http.post(url, payload).pipe(catchError(this.utils.processError.bind(this)))
    }
    else {
      return this.http.post(url, payload, { headers: this.utils.addTempTokenHeader }).pipe(catchError(this.utils.processError.bind(this)))
    }
  }

  getActiveCoupons() {
    let url = `${this.utils.apiUrl}Order/FetchCouponForCustomer`;
    let body: any = {
      "inventoryDetails": [
      ]
    }
    if (this.utils.getUserGuid()) {
      body['userGuidId'] = this.utils.getUserGuid() ? this.utils.getUserGuid() : '';
    }
    let cart: any = localStorage.getItem('cart');
    let cartInfo: any = JSON.parse(cart);
    if (cartInfo && cartInfo.length) {
      body.inventoryDetails = cartInfo.map((ele: any) => {
        return { inventoryGuidId: ele.inventoryGuId, quantity: ele.quantity }
      })
    }
    return this.http.post(url, body);
  }


  validateCoupon(couponName: any) {
    // if (isPlatformBrowser(this.platformId)) {
    let url = `${this.utils.apiUrl}Order/ApplyCouponForCustomer`;
    let body: any = {
      "purchaseTotalAmount": 0,
      couponCode: couponName ? couponName.toUpperCase() : '',
      "inventoryDetails": [
      ]
    }
    if (this.utils.getUserGuid()) {
      body['userGuidId'] = this.utils.getUserGuid() ? this.utils.getUserGuid() : '';
    }
    let buyNow: any = localStorage.getItem('buyNow');
    let buyNowCart: any = JSON.parse(buyNow);
    if (buyNowCart) {
      if (buyNowCart && buyNowCart.length) {
        body.inventoryDetails = buyNowCart.map((ele: any) => {
          body.purchaseTotalAmount += ((Number(ele.sellingPrice) * Number(ele.quantity)) - (Number(ele.discount) * Number(ele.quantity)));
          return { inventoryGuidId: ele.inventoryGuId, quantity: ele.quantity, purchaseAmount: ((Number(ele.sellingPrice) * Number(ele.quantity)) - (Number(ele.discount) * Number(ele.quantity))) }
        })
      }
    }
    else {
      let cart: any = localStorage.getItem('cart');
      let cartInfo: any = JSON.parse(cart);
      if (cartInfo && cartInfo.length) {
        body.inventoryDetails = cartInfo.map((ele: any) => {
          body.purchaseTotalAmount += ((Number(ele.sellingPrice) * Number(ele.quantity)) - (Number(ele.discount) * Number(ele.quantity)));
          return { inventoryGuidId: ele.inventoryGuId, quantity: ele.quantity, purchaseAmount: ((Number(ele.sellingPrice) * Number(ele.quantity)) - (Number(ele.discount) * Number(ele.quantity))) }
        })
      }
    }
    return this.http.post(url, body).pipe(catchError(this.utils.processError.bind(this)));
  // }
 
}

  getBlogData(blogId: any) {
    let url = `${this.utils.apiUrl}WordPress/GetPostDetailsbyPostId?postId=${blogId}`;
    return this.http.get(url).pipe(catchError(this.utils.processError.bind(this)));
  }

  getPressMediaDetailData(pMId: any) {
    let url = `${this.utils.apiUrl}CustomerConsultation/GetPressMediBbyPMId?pMId=${pMId}`;
    return this.http.get(url).pipe(catchError(this.utils.processError.bind(this)));
  }

  getAllActiveBlogs(body: any) {
    let url = `${this.utils.apiUrl}WordPress/GetWordPressAllPostList`;
    return this.http.post(url, body).pipe(catchError(this.utils.processError.bind(this)));
  }

  getAllActiveCategoriesBlogs() {
    let url = `${this.utils.apiUrl}WordPress/GetAllCategories`;
    return this.http.get(url).pipe(catchError(this.utils.processError.bind(this)));
  }

  getCampaignPageData(guid: any, pageName: string) {
    let url = this.utils.apiUrl + 'StaticPageData/GetSeriesStaticPageDetailByGuidId?SeriesStaticPageGuid=' + guid;
    let body: any = {}
    body['guidId'] = guid ? guid : this.emptyGuid
      body['landingPageName'] = pageName
    return this.http.post(url, body, { headers: this.utils.skipInterceptorHeaders });
  }

  getManualPdf(manualName: any) {
    let url = this.utils.apiUrl + 'FileUpload/GetProductManual';
    return this.http.post(url, { manualFileName: manualName }, { headers: this.utils.skipInterceptorHeaders });
  }

  getSolarCalculatorSolution(data: any) {
    let url = this.utils.apiUrl + 'SolarCalculator/SolarCalculator';
    return this.http.post(url, data, { headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)));
  }

  requestACallback(data: any) {
    let url = this.utils.apiUrl + 'CustomerConsultation/RequestACallBack';
    return this.http.post(url, data, { headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)));
  }

  fetchOrderDetail(body: any) {
    let url = this.utils.apiUrl + `Order/TrackOrderDetails?orderNumber`;
    return this.http.post(url, body, { headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)));
  }

  getRedirectUrl(url:string)
  {
    let body= {
      "email": environment.emailForRoutes,
      "password": environment.passwordForRoutes,
      "urlKey": url
    }
    return this.http.post('https://'+environment.apiDomain+environment.pathForRoutes, body, { headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)));
  }

  getSearchTermResults(data: any) {
    let url = `${this.utils.apiUrl}Product/SearchProducts?searchTerm=${encodeURIComponent(data)}`;
    return this.http.post(url, { headers: this.utils.skipInterceptorHeaders }).pipe(
      catchError(this.utils.processError.bind(this))
    );
  }

}


